'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _DataSelector = require('../../common/Class/DataSelector');

var _DataSelector2 = _interopRequireDefault(_DataSelector);

var _Helpers = require('../../common/Helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  ingrid: new _DataSelector2.default('data-ingrid'),
  gridContainers: new _DataSelector2.default('data-mix-grid'),
  gridItem: 'product-grid-item'
};
var dom = {};

var cacheDom = function cacheDom() {
  dom.ingrids = selectors.ingrid.nodes();
};

/**
 * @desc set each ingrid height to the height of the first grid item in that grid.
 *  Note: this is only necessary if the ingrid is the fifth item.
 */
var setIngridHeights = function setIngridHeights() {
  dom.ingrids.map(function (el) {
    return {
      gridParent: el.closest(selectors.gridContainers.bracketed()),
      ingrid: el
    };
  }).filter(function (obj) {
    return !!obj.gridParent;
  }).map(function (obj) {
    return Object.assign(obj, {
      firstGridItem: [].concat((0, _toConsumableArray3.default)(obj.gridParent.querySelectorAll('.' + selectors.gridItem))).filter(function (el) {
        return !!el.offsetParent;
      })[0]
    });
  }).filter(function (obj) {
    return !!obj.firstGridItem;
  }).forEach(setIngridHeight);
};

var setIngridHeight = function setIngridHeight(_ref) {
  var ingrid = _ref.ingrid,
      firstGridItem = _ref.firstGridItem;

  var _firstGridItem$getBou = firstGridItem.getBoundingClientRect(),
      height = _firstGridItem$getBou.height;

  if (!height) {
    return;
  }

  ingrid.style.height = height + 'px';
};

var debouncedIngridSetter = (0, _Helpers.debounce)(setIngridHeights);

var bindListeners = function bindListeners() {
  window.addEventListener('resize', debouncedIngridSetter);
};

var init = exports.init = function init() {
  cacheDom();
  bindListeners();
  setIngridHeights(dom.ingrids);
};